import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServiceRoute } from '../../base/service-route';
import { CommonHttpOption } from '../../base/common-http-option';
import { CoreService } from '../../base/core';
import { ICash } from 'src/app/interfaces/cash';
import { ICashPerson } from 'src/app/interfaces/cashPerson';

@Injectable({
  providedIn: 'root'
})
export class CashService {

  constructor(private core: CoreService) { }

  list(branchEncryptId: string, page: number = 1, pageSize: number = 10): Observable<any> {
    return this.core.get(
      ServiceRoute.cash.list + branchEncryptId,
      new CommonHttpOption().headers,
      new CommonHttpOption().paginator(page, pageSize)
    );
  }
  add(data: ICash): Observable<any> {
    return this.core.post(
      ServiceRoute.cash.add,
      data,
      new CommonHttpOption().headers
    );
  }

  edit(data: ICash) {
    return this.core.put(
      ServiceRoute.cash.edit,
      data,
      new CommonHttpOption().headers
    );
  }

  personAdd(data: ICashPerson) {
    return this.core.post(
      ServiceRoute.cash.personAdd,
      data,
      new CommonHttpOption().headers
    );
  }

  personDelete(data: any) {
    return this.core.post(
      ServiceRoute.cash.personDelete,
      data,
      new CommonHttpOption().headers
    );
  }

  activeDeactive(data: any) {
    return this.core.put(
      ServiceRoute.cash.activeDeactive,
      data,
      new CommonHttpOption().headers
    );
  }

}
